import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './home';
import { ApiDocsComponent } from './api-docs';
import { TestConnectionComponent } from './test-connection';
import { SchedulesComponent } from './schedules';
import { PortsComponent } from './ports';
import { CarriersComponent } from './carriers';
import { VesselsComponent } from './vessels';
import { WebSearchComponent } from './web-search';
import { PlansComponent } from './plans';
import { PageNotFoundComponent } from './page-not-found.component'

import { RegisterComponent } from './register';
import { ConfirmComponent } from './confirm';
import { AboutComponent, ApiComponent, AnalyticsComponent, ContactComponent, DataFeedsComponent, PrivacyPolicyComponent, TermsOfUseComponent, HelpComponent, SolutionsComponent, ApplicationComponent, WhatWeDoComponent, OnlineSearchComponent, ApiOverviewComponent, CarrierNetworkComponent, DataConsolidationComponent, DataFormatsComponent, AboutLandingComponent, UpcomingEventsComponent } from './static';


const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'api-docs', component: ApiDocsComponent },
  { path: 'test-connection', component: TestConnectionComponent },
  { path: 'schedules', component: SchedulesComponent },
  { path: 'ports/:id', component: PortsComponent },
  { path: 'carriers/:id', component: CarriersComponent },
  { path: 'vessels/:id', component: VesselsComponent },
  { path: 'plans', component: PlansComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'confirm', component: ConfirmComponent },
  { path: 'bulk-data-feeds', component: DataFeedsComponent },
  { path: 'blog', loadChildren: function() { return new Promise(function (resolve, reject) {  (require as any).ensure([], function (require: any) {    resolve(require('.\\blog\\blog.module')['BlogModule']);  }, function(e: any) {    reject({ loadChunkError: true, details: e });  });}) } },
  { path: 'press', loadChildren: function() { return new Promise(function (resolve, reject) {  (require as any).ensure([], function (require: any) {    resolve(require('.\\press\\press.module')['PressModule']);  }, function(e: any) {    reject({ loadChunkError: true, details: e });  });}) } },
  { path: 'who-we-are', component: AboutComponent },
  { path: 'api-data-on-demand', component: ApiComponent },
  { path: 'analytics-reporting', component: AnalyticsComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'terms-of-use', component: TermsOfUseComponent },
  { path: 'help', component: HelpComponent },
  { path: 'account', loadChildren: function() { return new Promise(function (resolve, reject) {  (require as any).ensure([], function (require: any) {    resolve(require('.\\account\\account.module')['AccountModule']);  }, function(e: any) {    reject({ loadChunkError: true, details: e });  });}) } },
  { path: 'solutions', component: SolutionsComponent },
  { path: 'application', component: ApplicationComponent },
  { path: 'subscribe', component: WebSearchComponent },
  { path: 'what-we-do', component: WhatWeDoComponent },
  { path: 'online-search', component: OnlineSearchComponent },
  { path: 'api-overview', component: ApiOverviewComponent },
  { path: 'carrier-list', component: CarrierNetworkComponent },
  { path: 'data-consolidation', component: DataConsolidationComponent },
  { path: 'bulk-data-formats', component: DataFormatsComponent },
  { path: 'about', component: AboutLandingComponent },
  { path: 'upcoming-events', component: UpcomingEventsComponent },
  { path: '**', component: PageNotFoundComponent }
];

// lazy loaded children must have a route readable by webpack

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/app-routing.module.ts